<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>
      <div class="top">
        <nav class="navbar navbar-light bg-light">
          <form class="" style="width:100vw;text-align: center;">
            <div class="btPro">
              <button class="btn btn-outlines-secondary font-color" type="button">
                สำเร็จ
              </button>
            </div>
            <div class="btDo">
              <a
                @click="goto('Redeem08')"
                class="btn btn-outlines-success "
                type="button"
              >
                กำลังดำเนินการ
              </a>
            </div>
            <!--div class="line-c">
              <hr class="new4" />
            </div>
            <div class="line-d">
              <hr class="new5" />
            </div-->
          </form>
        </nav>
      </div>
      <!-- list completed -->
      <div
        class="row bg-white s redeem-history"
        v-for="item in approvedList"
        v-bind:key="item._id"
      >
        <a @click="goto('RedeemHistoryDetail', item._id)">
          <img
            class="img-profile-redeem9"
            :src="'https://api.loyaltyhub.me/public/' + item.rewardId.image"
            v-if="item.rewardId.image != ''"
          />
          <span style="color: #7bc79a; font-weight: 600;">แลกคะเเนนสำเร็จ</span>
          <span>{{ updatedAt(item.updatedAt) }}</span>
          <span>แลก  {{ item.reward_name }}</span>
          <span>มูลค่า  {{ item.reward_value  | numFormat('0,000,000.00')}} บาท</span> 
          <span>คะแนนที่ใช้ {{ item.point  | numFormat('0,000,000')}} คะแนน</span>
          
        </a>
      </div>
      <div class="lastrow"></div>
      <!-- <div class="row bg-white s">
        <div>
          <img
            class="img-profile"
            src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-redeem-point-img-02.jpg"
          />

          <span class="name-status">แลกคะเเนนสำเร็จ</span>
          <span class="name-now">18 เม.ย 2564</span>
          
          <span class="name-price">2,000</span>
          <span class="name-price">คะเเนน</span>
          <span class="name-time">แลกรับ ลำโพงบลูทูธ JBL FLIP 5</span>
        </div>
      </div>
      -->
    </body>
  </html>
</template>
<script>
import Navbar from "./navbar";
import { DateTimeFunc } from "../libs/constant.js";
export default {
  name: "RedeemHistory",
  components: {
    navbar: Navbar,
  },
  filters:{
    translateStatus: function(val){
      if(val == "Completed" || val == "Approved"){
        return "สำเร็จ";
      }else if(val == "Cancelled" || val == "Cancelled"){
        return "ยกเลิก";
      }else{
         return "กำลังดำเนินการ";
      }
    }
  },
  data() {
    return {};
  },
  beforeMount() {
        this.$store.dispatch("redeemHistory", {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
          id: this.$store.state.profile._id,
        });
     
  },
  computed: {
    
    approvedList() {
      return this.$store.state.redeem.history.filter((item) => {
        if(item.rewardId===null){
          item.rewardId = {
              name:"Adjust Point",
              image: ""
              
            }
        }
        return item.status == "Approved";
      });
      
    },
  },
  mounted() {
    console.log(this.$store.state.redeem.history);
  },
  methods: {
   
       //this.approvedList = await axios.get(); 
       //this.$store.dispatch("redeemHistory",{id: localStorage.getItem("})


    updatedAt(date) {
      console.log("updatedAt");
      console.log(date);
      let ymd = date.substring(0, 10).split("-");
      //return "";
      let month = DateTimeFunc.TH_MONTH(ymd[1]);
      return ymd[2] + " " + month + " " + (parseInt(ymd[0]) + 543);
    },
    goto(page, index) {
      console.log(page);
      this.$router.push({
        name: page,
        params: {
          rewardIndex: index || "",
        },
      });
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";

.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl,
.container-xxl {
  width: 100%;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: 9%;
}
.btn-outlines-success {
  font-family: "Prompt";
  color: #7f8285;
  border-color: #963c3c00;
  background-color: transparent !important;
  font-weight: bold;
  width: 100%;
  float: right;
  font-size: 19px;
    -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.btn-outlines-secondary {
  font-family: "Prompt";
  color: #7bc79a;
  border-color: hsla(0, 0%, 100%, 0);
  font-weight: 700;
  width: 100%;
  background-color: transparent !important;
  float: left;
  font-size: 19px;
  margin-left: 5px;
    -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.navbar {
  color: #ffffff;
}
.bg-dark {
  background-color: #ffffff !important;
  height: 100px;
}
.row {
  margin-right: 9px !important;
  margin-left: 18px !important;
}

.title-page-l {
  width: 100%;
  top: 20px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: "Prompt";
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: "Prompt";
  letter-spacing: 2px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  text-align: left;
}
.title-page-r {
  top: 19px;
  position: absolute;
  overflow: visible;
  background: #ffffff;
  border-radius: 30px;
  width: 149px;
  left: 200px;
  height: 29px;
}
.title-page-r p {
  color: #7bc79a;
  padding-top: 10px;
  top: -14px;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  height: 150px;
  width: 340px;
  position: relative;
  overflow: visible;
  top: -2px;
}
.bg-white.s {
  border-radius: 10px;
  width: 340px;
  position: relative;
  overflow: visible;
  margin-top: 15px;
  top: -6px;
}
.bg-white.ss {
  border-radius: 10px;
  height: 100%;
  width: 95%;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}

h1 {
  font-size: 20px;
  margin-top: 12px;
  margin-left: 12px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
  margin-left: 12px;
  margin-top: -12px;
}
.img-profile-redeem9 {
  display: block;
  margin-left: 9;
  margin-right: 9;
  margin-top: 21px;
  padding-right: 12px;
  width: 109px;
  height: 87px;
  float: left;
}
.name-status {
  font-family: "Prompt";
  color: #7bc79a;
  margin-top: 13px;
  font-size: 14px;
  font-weight: 700;
}
.name-now {
  font-family: "Prompt";
  color: #585858cb;
  margin-top: 13px;
  font-size: 9px;
  font-weight: bold;
  padding: 2px 2px 2px 23px;
}
.name-price {
  font-family: "Prompt";
  color: #000000;
  margin-top: 3px;
  font-size: 15px;
  padding: 7px 5px 3px 6px;
}
.name-time {
  font-family: "Prompt";
  color: #000000;
  margin-top: 32px;
  margin-bottom: 0px;
  font-size: 14px;
}
.pon {
  display: block;

  margin-right: 2px;
  margin-top: 8px;
  width: 33px;
  height: 33px;
  float: left;
}
.pon-t {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
}
.progress {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 2px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #7bc79a;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #7bc79a;
  border-radius: 53px;
}
.lastrow {
  margin-bottom: 200px;
}
</style>
